<template>
  <div class="foot-btn">
    <button @click="buttonClick">{{text}}</button>
  </div>
</template>

<script>
export default {
  name: 'page-button',
  data () {
    return {

    }
  },
  props: {
    text: {
      type: String,
      default: '确认'
    }
  },
  methods: {
    buttonClick () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="less" scoped>
.foot-btn{
  padding: 0 17px;
  height: 40px;
  button{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 15px;
    color: #FEFEFE;
    border-radius:20px;
    background:linear-gradient(-90deg,rgba(53,76,185,1),rgba(68,103,197,1));
  }
  &.unclick {
    button {
      background: #efefef;
      color: #333;
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/page-button.vue